// extracted by mini-css-extract-plugin
module.exports = {"bind":"bind_bind_24dOK"};